import { render } from "./EventCard.vue?vue&type=template&id=ec6bee02&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=ec6bee02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec6bee02"

export default script